var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.768 11.1a.8.8 0 0 1 1.131 1.132L4.431 16.7H7.5a.8.8 0 1 1 0 1.6h-5a.8.8 0 0 1-.8-.8v-5a.8.8 0 1 1 1.6 0v3.068zM18.3 7.5a.8.8 0 1 1-1.6 0V4.43L12.232 8.9a.8.8 0 0 1-1.131-1.132L15.569 3.3H12.5a.8.8 0 1 1 0-1.6h5a.8.8 0 0 1 .8.8z"
})));
SvgExpand.displayName = "SvgExpand";
export { SvgExpand as ReactComponent };
export default SvgExpand;